import { bopApi } from '@/lib/api/client';

/**
 * Kicks off the async GDPR Article-15 report for a user. The PDF is not returned here — bop-api renders
 * it and pushes a presigned URL over the WebSocket ({type:'fileDownload'}); callers must mount
 * useFileDownloadListener. The justification is recorded in the audit log.
 */
export const requestGdprReport = (pid: string, justification: string) => bopApi.post(`v1/compliance/gdpr/report/${pid}`, { json: { formats: ['pdf'], justification } }).text();
